
// sallu local
// export const api_url = 'http://192.168.30.241:3000';

// staging link
// export const api_url = 'http://54.87.33.204:3000'; 

// abdullah localip
// export const api_url = 'http://192.168.30.38:5000/api/';
// export const socket_api_url = 'http://192.168.30.38:5000/';
// abdullah localipw
// export const api_url = 'http://34.224.7.63:5000/api/';
// export const api_url = 'http://192.168.30.38:3000';
// dev link
// export const chainId = '11155111';
// export const api_url = 'http://52.91.230.95:5001/api/';
// export const socket_api_url = 'http://52.91.230.95:5001/';

// Mainnet link
export const chainId = '42161';
export let api_url;
export let socket_api_url;
export const tokenReservesForFirstBuying = "10730.00191";
export let reserveWETHForFirstBuying;

//Updated ARB contracts with ETH
export const wETHContract = "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
export const rockRelayerContract = "0x987D2901CF1F0c7BfA8d9254FdD7e7028A5560F1"
export let gemsRouterContract;
export let gemsFactoryContract;
export let graduationAmount
export let kingOfClassAmount
export let afterGraduationTradingFeeWallet;
export const gems = "0x28bc3f91E153CFfAF7f8C895784A8EA3e1730bf3";
export const uniSwapContract = '0x1F98431c8aD98523631AE4a59f267346ea31F984';

const DEV_After_Graduation_Trading_Fee_Wallet = '0xB09540Cdb198d8ae82710e95c53C6CDebc7680a8'
const PROD_After_Graduation_Trading_Fee_Wallet = '0xE3e026217BB49215B229501F8f29Bf5ac6E1a1B2'

const ROUTER_DEV_CONTRACT = '0x9E36454C4002528BCbCC04B15893660Cb9cB2e79'
const FACTORY_DEV_CONTRACT = '0x251282C906d47caaeAEb2e8039de8991Ce026416'

const ROUTER_PROD_CONTRACT = '0x6a2439A15F3758cf093C8fBfa2b0A025cCdb48b4'
const FACTORY_PROD_CONTRACT = '0xFBBa6CF1216801D18902a5CbA21E667a28C9cA67'

const dev = 'development'
const system_ENV = process.env.REACT_APP_ENV
if (system_ENV === dev) {
    gemsRouterContract = ROUTER_DEV_CONTRACT
    gemsFactoryContract = FACTORY_DEV_CONTRACT
    afterGraduationTradingFeeWallet = DEV_After_Graduation_Trading_Fee_Wallet
    api_url = 'https://dev-api.cryptonames.io/api/'
    socket_api_url = 'https://dev-api.cryptonames.io/';
    graduationAmount = 0.0011;
    kingOfClassAmount = 0.000528;
    reserveWETHForFirstBuying = "352941176885813";
}
else {
    gemsRouterContract = ROUTER_PROD_CONTRACT
    gemsFactoryContract = FACTORY_PROD_CONTRACT
    afterGraduationTradingFeeWallet = PROD_After_Graduation_Trading_Fee_Wallet
    api_url = 'https://api.cryptonames.io/api/'
    socket_api_url = 'https://api.cryptonames.io/';
    graduationAmount = 0.525;
    kingOfClassAmount = 0.252;
    reserveWETHForFirstBuying = "185294117865051903";
}